import { DocumentPricingDataSchema } from "@buildwithflux/models";
import { DocumentPricingRepository } from "./DocumentPricingRepository";
export class FirestoreDocumentPricingRepository extends DocumentPricingRepository {
    db;
    logger;
    firestoreSubscriptionsByPricingDataId = new Map();
    // eslint-disable-next-line
    constructor(db, logger) {
        super();
        this.db = db;
        this.logger = logger;
    }
    async createPricingRecord(documentUid, pricingData) {
        const collection = this.db.documentPricingCollection(documentUid);
        await collection.doc("latest").set(pricingData);
        // TODO: should we also create a timestamped price record so we have a time series?
    }
    async getLatestPricing(documentUid) {
        const collection = this.db.documentPricingCollection(documentUid);
        const latest = await collection.doc("latest").get();
        if (!latest.data())
            return undefined;
        const result = DocumentPricingDataSchema.safeParse(latest.data());
        if (result.success) {
            return result.data;
        }
        else {
            this.logger.warn(`Latest pricing data for document ${documentUid} is missing or invalid`, {
                parseError: result.error,
            });
            return undefined;
        }
    }
    subscribeToLatestPricing(documentUid, onChange) {
        const latestPricingRef = this.db.documentPricingCollection(documentUid).doc("latest");
        const unsubscribe = this.subscriptionMgr.addSubscription(documentUid, onChange, () => {
            const existingSubCount = this.subscriptionMgr.listenerCount(documentUid);
            if (existingSubCount === 0) {
                const firestoreUnsub = this.firestoreSubscriptionsByPricingDataId.get(documentUid);
                if (firestoreUnsub) {
                    firestoreUnsub();
                    this.firestoreSubscriptionsByPricingDataId.delete(documentUid);
                }
            }
        });
        // NOTE: We're using a multiplexing pattern here.  There may be multiple logical subscribers to firestore,
        // but we create exactly one subscription here.  When the subscription is triggered, it causes all of the
        // logical subscriptions to fire as well.
        const existing = this.firestoreSubscriptionsByPricingDataId.get(documentUid);
        if (!existing) {
            const firestoreUnsubscriber = latestPricingRef.onSnapshot((snap) => {
                if (!snap)
                    return;
                const result = DocumentPricingDataSchema.safeParse(snap.data());
                if (result.success) {
                    this.notifyPricingChangeListeners(documentUid, result.data);
                }
                else {
                    this.notifyPricingChangeListeners(documentUid, null);
                }
            });
            this.firestoreSubscriptionsByPricingDataId.set(documentUid, firestoreUnsubscriber);
        }
        // NOTE: custom cleanup logic here: we check to see if there are any subscribers left.  As long as there are,
        // we keep our subscription open.  Once there aren't any remaining, we shut it down.
        return unsubscribe;
    }
}
//# sourceMappingURL=FirestoreDocumentPricingRepository.js.map